export default "__VITE_ASSET__Ly12t4G___"